import { render, staticRenderFns } from "./CompanyRegisterLangForm.vue?vue&type=template&id=9c796794"
import script from "./CompanyRegisterLangForm.vue?vue&type=script&lang=js"
export * from "./CompanyRegisterLangForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.20_css-loader@6.11.0_@rspack+core@1.5.0_@swc+h_83b9284dd63eedf3f9170fbde5313985/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports